import React, { useState, forwardRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Typography,
  Button,
  Box,
} from '@mui/material';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Brands({ open, onClose, onBrandFilter }) {
  const [selectedBrands, setSelectedBrands] = useState([]);

  const brands = ['Native Supply', 'IV His Glory', 'Elevated Faith', 'Kidan Clothing', 'Nhim Apparel', 
    'Forty-Six Ten Apparel', 'Salt and Light', 'Hosanna Revival',  'The Daily Grace', 'We The Believers',
    'God above all ✞', 'Scary But Beautiful', 'Red Letter Clothing', 'His Glory Shop', 'Reyna Signature', 'Malta Apparel', 'Art Of Homage'];

  const handleChange = (brand) => {
    const updatedBrands = selectedBrands.includes(brand)
      ? selectedBrands.filter((b) => b !== brand)
      : [...selectedBrands, brand];
    setSelectedBrands(updatedBrands);
    onBrandFilter(updatedBrands); // Pass the selected brands to the parent
  };

  const handleReset = () => {
    setSelectedBrands([]);
    onBrandFilter([]); // Reset the brand filter in the parent
  };

return (
    <Dialog
        open={open}
        onClose={onClose}
        slotProps={{ transition: Transition,
            paper: {
                sx: { borderRadius: '16px 16px 16px 16px', position: 'absolute', bottom: 0, width: '90%' },
            },
         }}
        fullWidth
        maxWidth="md"           
    >
        <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Select Brands
            </Typography>
        </DialogTitle>
        <DialogContent>
            <Box>
                    {brands.map((brand) => (
                    <Button
                    key={brand}
                    onClick={() => handleChange(brand)}
                    variant={selectedBrands.includes(brand) ? 'contained' : 'outlined'}
                    sx={{
                        borderRadius: 20, // Pill shape
                        m: 1, // Margin between buttons
                        textTransform: 'none', // Prevents uppercase text
                        borderColor: 'black',
                        color: selectedBrands.includes(brand) ? 'white' : 'black',
                        backgroundColor: selectedBrands.includes(brand) ? 'black' : 'transparent',
                        '&:hover': {
                        borderColor: 'black',
                        backgroundColor: selectedBrands.includes(brand)
                            ? 'rgba(0, 0, 0, 0.8)'
                            : 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                    >
                    {brand}
                    </Button>
                ))}
            </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleReset} sx={{ flex: 1, color: 'black' }}>
                Reset
            </Button>
            <Button onClick={onClose} variant="contained" sx={{ flex: 1, backgroundColor: 'black', color: 'white' }}>
                Done
            </Button>
        </DialogActions>
    </Dialog>
);
}